const products = [
  {
    id: "vpn",
    name: "LINIJE VPN",
    tagline: "Secure & Private Browsing",
    description:
      "A next-generation VPN for iOS that encrypts your internet connection and protects your identity. With blazing-fast servers across the globe, your data stays yours — always.",
    image: "https://public.readdy.ai/ai/img_res/fe8598bdba939210f5a9a83d8b696d31.jpg",
    accent: "teal",
    highlights: [
      { icon: "ri-shield-flash-line", text: "AES-256 Encryption" },
      { icon: "ri-global-line", text: "50+ Server Locations" },
      { icon: "ri-timer-flash-line", text: "One-Tap Connect" },
      { icon: "ri-eye-off-line", text: "Zero-Log Policy" },
    ],
  },
  {
    id: "cleaner",
    name: "LINIJE Cleaner",
    tagline: "Peak Device Performance",
    description:
      "An intelligent iPhone optimization tool that removes junk files, duplicates, and unnecessary data — freeing up storage and boosting performance so your device runs like new.",
    image: "https://readdy.ai/api/search-image?query=phone%20cleaner%20app%20iOS%20interface%20dark%20design%20glowing%20amber%20orange%20sparkle%20refresh%20icon%20performance%20boost%20visualization%20clean%20minimal%20smartphone%20optimization%20abstract%20modern%20mobile%20app%20interface&width=600&height=800&seq=3&orientation=portrait",
    accent: "amber",
    highlights: [
      { icon: "ri-delete-bin-6-line", text: "Smart Junk Removal" },
      { icon: "ri-image-line", text: "Duplicate Photo Finder" },
      { icon: "ri-speed-up-line", text: "Performance Boost" },
      { icon: "ri-safe-2-line", text: "Safe & Secure Cleaning" },
    ],
  },
];

export default function ProductsSection() {
  return (
    <section id="products" className="py-28 bg-[#080C14]">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <span className="text-teal-400 text-xs font-bold tracking-[0.3em] uppercase block mb-4">Our Products</span>
          <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight mb-6">
            Crafted for iOS. <span className="text-teal-400">Built to Excel.</span>
          </h2>
          <p className="text-white/50 text-lg max-w-xl mx-auto leading-relaxed">
            Two powerful applications designed to enhance every aspect of your iPhone experience.
          </p>
        </div>

        {/* Product cards */}
        <div className="flex flex-col gap-20">
          {products.map((product, idx) => (
            <div
              key={product.id}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${idx % 2 === 1 ? "lg:flex-row-reverse" : ""}`}
              style={{ direction: idx % 2 === 1 ? "rtl" : "ltr" }}
            >
              {/* Image */}
              <div className="flex justify-center" style={{ direction: "ltr" }}>
                <div
                  className={`relative w-[280px] h-[500px] rounded-[3rem] overflow-hidden border-4 shadow-2xl ${
                    product.accent === "teal"
                      ? "border-teal-500/40 shadow-teal-500/20"
                      : "border-amber-500/40 shadow-amber-500/20"
                  }`}
                >
                  <img
                    src={product.image}
                    alt={product.name}
                    className="w-full h-full object-cover object-top"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#080C14]/60 to-transparent" />
                </div>
                {/* Glow effect */}
                <div
                  className={`absolute w-[200px] h-[200px] rounded-full blur-3xl opacity-20 ${
                    product.accent === "teal" ? "bg-teal-400" : "bg-amber-400"
                  }`}
                />
              </div>

              {/* Content */}
              <div style={{ direction: "ltr" }}>
                <div
                  className={`inline-flex items-center gap-2 rounded-full px-4 py-1.5 mb-6 text-xs font-bold uppercase tracking-widest ${
                    product.accent === "teal"
                      ? "bg-teal-500/10 text-teal-400 border border-teal-500/20"
                      : "bg-amber-500/10 text-amber-400 border border-amber-500/20"
                  }`}
                >
                  <i className="ri-apple-line" />
                  iOS Application
                </div>

                <h3 className="text-3xl md:text-4xl font-bold text-white mb-3">{product.name}</h3>
                <div
                  className={`text-lg font-semibold mb-5 ${
                    product.accent === "teal" ? "text-teal-400" : "text-amber-400"
                  }`}
                >
                  {product.tagline}
                </div>
                <p className="text-white/60 leading-relaxed mb-8 text-base">{product.description}</p>

                {/* Highlights */}
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {product.highlights.map((h) => (
                    <div
                      key={h.text}
                      className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-xl px-4 py-3"
                    >
                      <div
                        className={`w-8 h-8 flex items-center justify-center rounded-lg ${
                          product.accent === "teal"
                            ? "bg-teal-500/15 text-teal-400"
                            : "bg-amber-500/15 text-amber-400"
                        }`}
                      >
                        <i className={`${h.icon} text-base`} />
                      </div>
                      <span className="text-white/80 text-sm font-medium">{h.text}</span>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
